module.exports = __webpack_public_path__ + "img/back-arrow.2b1a5289.svg";